import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {Button} from '@components';
import {useTranslation} from "react-i18next";
import {checkRole} from "@app/services/mainService";
import {mainService} from "@app/services/mainService";
import {alertService} from "@app/services/alertService";
import {useSelector} from "react-redux";


const SettingsTab = ({isActive}) => {
    const [t] = useTranslation();
    const [loading, setLoading] = useState(false);
    const initialNhanvien = {
        id: 0,
        dangnhap: '',
        ten: '',
        matkhau: '',
        dienthoai: '',
        diachi: '',
        email: ''
    };
    let user = useSelector((state) => state.auth.currentUser);

    let userTmp = localStorage.getItem("profile");
    if(userTmp)
        user = JSON.parse(userTmp);

    const [nhanvien, setNhanvien] = useState({...initialNhanvien});
    const onChangeInput = (e) => {
        const {name, value} = e.target;

        setNhanvien((prevState) => ({
            ...prevState,
            [name]: value
        }));

    };

    useEffect(async () => {
        setLoading(true);
        /*nhanvienService.getCurrentUser().then((response) => {
            //console.log('getById', JSON.stringify(response, null, 2));
            const userX = response.data.data;
            setNhanvien(userX);
        });*/
        setLoading(false);
    }, []);

    /*const taoPKClick = () => {
        let data = {
            id :nhanvien.id,
            ten :nhanvien.ten,
            dienthoai: nhanvien.dienthoai,
            diachi: nhanvien.diachi,
            email: nhanvien.email
        };


        if(!data.ten || data.ten.length <=0)
        {
            alert('Vui lòng nhập tên');
            return;
        }
        const  id = data.id;
        updateUser(id,data);

    };*/

    /*async function updateUser(idX, data) {
        setLoading(true);
        //delete data.ma;
        const result = await nhanvienService.update(idX, data);
        if (result.status) {
            alertService.success(t('fields.label.suathanhcong'));
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }*/
    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }
    return (
        <div className={`tab-pane ${isActive ? 'active' : ''}`}>
            <form className="form-horizontal">
                <div className="form-group row">
                    <label
                        htmlFor="ten"
                        className="col-sm-2 col-form-label"
                    >
                        {t('fields.label.name')}
                    </label>
                    <div className="col-sm-10">
                        <input
                            type="text"
                            className="form-control"
                            id="ten"
                            name="ten"
                            placeholder= {t('fields.label.name')}
                            value={user.name}
                            onChange={onChangeInput}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label
                        htmlFor="email"
                        className="col-sm-2 col-form-label"
                    >
                        Email
                    </label>
                    <div className="col-sm-10">
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="email"
                            value={user.email}
                            onChange={onChangeInput}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label
                        htmlFor="diachi"
                        className="col-sm-2 col-form-label"
                    >
                        {t('fields.label.address')}
                    </label>
                    <div className="col-sm-10">
                        <input
                            type="text"
                            className="form-control"
                            id="diachi"
                            name="diachi"
                            placeholder={t('fields.label.address')}
                            value={user.address}
                            onChange={onChangeInput}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label
                        htmlFor="dienthoai"
                        className="col-sm-2 col-form-label"
                    >
                        {t('fields.label.phone')}
                    </label>
                    <div className="col-sm-10">
                        <input
                            type="text"
                            className="form-control"
                            id="dienthoai"
                            name="dienthoai"
                            placeholder={t('fields.label.phone')}
                            value={user.phone}
                            onChange={onChangeInput}
                        />
                    </div>
                </div>
                {/*<div className="form-group row">
                    <div className="offset-sm-2 col-sm-10">
                        <Button  onClick={taoPKClick} theme="primary" icon="save">
                            {t('action.label.save')}
                        </Button>
                    </div>
                </div>*/}
            </form>
        </div>
    );
};

export default SettingsTab;
